module.exports = __webpack_public_path__ + "img/gestya.dbb89ccf.jpg";